<template>
  <div>
    <el-card style="margin: auto;">
      <div slot="header" class="clearfix">
        <span style="float:left; font-weight: 800">DNS 记录列表</span>
      </div>

      <el-form inline>
        <div style="float: left">
          <el-form-item label="域名">
            <el-select
              style="width: 150px;"
              :value="search_by_zone"
              placeholder="请选择域名"
              @change="search_records_by_zone"
            >
              <el-option
                v-for="i in zones"
                :key="i.id"
                :value="i.zoneName"
                :label="i.zoneName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="get_records(1)">查询</el-button>
          </el-form-item>
        </div>
      </el-form>

      <el-table style="margin-top: 15px;" :data="records" border>
        <el-table-column label="ID" prop="RecordId"></el-table-column>
        <el-table-column label="记录" prop="RR"></el-table-column>
        <el-table-column label="类型" prop="Type"></el-table-column>
        <el-table-column label="记录值" prop="Value"></el-table-column>
        <el-table-column label="TTL" prop="TTL"></el-table-column>
        <el-table-column label="线路" prop="Line"></el-table-column>
        <el-table-column label="域名" prop="DomainName"></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="text">
            <el-tag
              type="success"
              effect="dark"
              size="mini"
              v-if="text.row.Status === 'ENABLE'"
              >启用</el-tag
            >
            <el-tag
              type="danger"
              effect="dark"
              size="mini"
              v-else-if="text.row.Status === 'DISABLE'"
              >停用</el-tag
            >
            <el-tag type="warning" effect="dark" size="mini" v-else
              >异常</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="Remark"></el-table-column>
      </el-table>

      <div style="text-align: center; margin-top: 15px">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="page_size"
          @current-change="get_records"
        ></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      search_by_zone: "",
      total: 0,
      page_size: 0,
      zones: [{ id: 1 }],
      records: [],
    };
  },
  created() {
    this.page_size = this.config.pageSize;
    this.get_zones();
  },
  methods: {
    get_zones() {
      const _this = this;
      _this.$axios
        .get(_this.config.path + "/dnszones?currentPage=0&pageSize=20", {
          headers: {
            Authorization: "Bearer " + _this.config.getCookie(),
          },
        })
        .then(function(res) {
          if (res.data.success === false) {
            _this.$message({
              showClose: true,
              message: "获取规则列表失败: " + res.data.message,
              type: "error",
            });
          } else {
            console.log("zones:", res.data.data);
            _this.zones = res.data.data;
          }
        })
        .catch(function(err) {
          _this.$message({
            showClose: true,
            message: "获取域名列表失败: " + err.toString(),
            type: "error",
          });
        });
    },
    search_records_by_zone(value) {
      this.search_by_zone = value;
      console.log("current search by zone: ", this.search_by_zone);
      this.get_records(1);
    },
    get_records(page) {
      const _this = this;
      let url =
        _this.config.path +
        "/dnsrecords?currentPage=" +
        page +
        "&pageSize=" +
        this.page_size;
      if (_this.search_by_zone !== "") {
        url = url + "&zone=" + _this.search_by_zone;
      }
      console.log("now url: ", url);
      _this.$axios
        .get(url, {
          headers: {
            Authorization: "Bearer " + _this.config.getCookie(),
          },
        })
        .then(function(res) {
          if (res.data.success === false) {
            if (res.data.message === "no record found") {
              return;
            }
            _this.$message({
              message: "获取记录列表失败: " + res.data.message,
              type: "error",
              showClose: true,
            });
          } else {
            _this.total = res.data.page.totalCount;
            _this.records = res.data.data;
            console.log(res.data.data);
          }
        })
        .catch(function(err) {
          _this.$message({
            message: "获取记录列表失败: " + err.toString(),
            type: "error",
            showClose: true,
          });
          console.log("get records list error: ", err.toString());
        });
    },
  },
};
</script>

<style>
.editable-btn {
  margin: 8px;
}
</style>
